import { type InferType, object, string } from "yup";

export enum BankDetailsInputFields {
  BankName = "bankName",
  BankCountry = "bankCountry",
  BicSwiftCode = "bicSwiftCode",
  BankCountryValidatedCountry = "bankCountryValidatedCountry",
}

export const SepaBankDetailsInputSchema = object().shape({
  [BankDetailsInputFields.BankName]: string()
    .required("Required field")
    .max(100, "Must be 100 characters or less")
    .matches(/\S/, "Bank name cannot be just spaces."),
  [BankDetailsInputFields.BankCountry]: string(),
  [BankDetailsInputFields.BankCountryValidatedCountry]: string().optional(),
  [BankDetailsInputFields.BicSwiftCode]: string()
    .optional()
    .transform((v: string | undefined) => (v ? v.replace(/\s/g, "").toUpperCase() : v))
    .test(
      "bic-swift-format",
      "SWIFT/BIC must be 8 or 11 alphanumeric characters",
      (value) => !value || /^[A-Z0-9]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(value),
    ),
});

export type SepaBankDetailsInputType = InferType<typeof SepaBankDetailsInputSchema>;
